import React from "react";
import Navb from "../../../../components/navbar/Navb";
import Footer from "../../../../components/footer/Footer";
import Img1 from "./img1.png";
import Recpiesimg1 from "./recpiesimg1.png";
import Recpiesimg2 from "./recpiesimg2.png";
import Recpiesimg3 from "../../img4.png";
import Recpiesimg4 from "../../img2.png";
import Recpiesimg5 from "../../img6.png";
import RecipiePage from "../../../../components/recipiePage/RecipiePage";
import Timer from "../timer.png";
import "../recipe.css";
const Wholeattacookies = () => {
  return (
    <>
      <RecipiePage
        Recpiesimg1={Recpiesimg1}
        Recpiesimg2={Recpiesimg2}
        Recpiesimg3={Recpiesimg3}
        Recpiesimg4={Recpiesimg4}
        Recpiesimg5={Recpiesimg5}
        Img1={Img1}
        Name="Whole Atta Cookies"
        Ul1={
          <ul>
            <li>
              <span className="Bold">Nandi whole wheat flour (atta)</span>
            </li>
            <li>baking powder</li>
            <li>salt</li>
            <li>brown sugar</li>
            <li>granulated sugar</li>
            <li>egg</li>
          </ul>
        }
        Ul2={
          <ul className="noDecoration">
            <li>1 cups</li>
            <li>1/2 teaspoon</li>
            <li>1/4 teaspoon</li>
            {/* <li>1/2 cups</li> */}
            <li>1/2 cups</li>
            <li>1/4 cups</li>
            <li>1 large</li>
          </ul>
        }
        Ul3={
          <ul>
            <li>vanilla extract</li>
            <li>chocolate chips</li>
            <li>boiled and mashed potatoes</li>
            {/* <li>finely chopped onions</li> */}
            <li>chopped coriander leaves</li>
            <li>cumin powder</li>
            <li>garam masala</li>
          </ul>
        }
        Ul4={
          <ul className="noDecoration">
            <li>1 teaspoon</li>
            <li>1 cup</li>
            <li>1 cup</li>
            {/* <li>1/2 cup</li> */}
            <li>1/4 cup</li>
            <li>1/2 teaspoon</li>
            <li>1/2 teaspoon</li>
          </ul>
        }
        Ol1={
          <ol>
            <li>
            Preheat your oven to 350°F (175°C). Line baking sheets with parchment paper.
            </li>
            <li>In a bowl, whisk together whole wheat flour, baking soda, and salt.</li>
            <li>In another large bowl, cream together the softened butter, brown sugar, and granulated sugar until smooth.</li>
            <li>Beat in the egg and vanilla extract until well combined.</li>
            <li>Gradually add the dry ingredients to the wet ingredients, mixing until just combined.</li>
            <li>Fold in the chocolate chips.</li>
            <li>Drop rounded tablespoons of dough onto the prepared baking sheets, spacing them about 2 inches apart.</li>
            <li>Bake for 10-12 minutes or until the edges are golden brown.</li>
            <li>Allow the cookies to cool on the baking sheets for a few minutes before transferring them to a wire rack to cool completely.</li>
          </ol>
        }
        Item1="Maida Pizza Cone"
        Item2="Mix Veg Paratha "
        Item3="Besan Kadhi & Rice"
        Link1="maidavegpizzacones"
        Link2="mixvegparatha"
        Link3="besankadhirice"
      />
      {/* <Navb />
      <div className="singleRecipeTop">Whole Atta Cookies</div>
      <img className="singleRecipeTopimg" src={Recpiesimg1} alt="Recpiesimg1" />
      <div className="singleRecipeBot">
        <div className="singleRecipeBotLeftItems">
          <div className="singleRecipeBotLeftItemTitle">INGREDIENTS</div>
          <hr />
          <div className="singleRecipeBotLeftItem">
            <ol>
              <li>
                1 cup{" "}
                <span className="Bold">
                  Nandi whole wheat flour (atta)
                </span>{" "}
              </li>
              <li>1/2 teaspoon baking soda</li>
              <li>1/4 teaspoon salt</li>
              <li>1/2 cup unsalted butter, softened</li>
              <li>1/2 cup brown sugar</li>
              <li>1/4 cup granulated sugar</li>
              <li>1 large egg</li>
              <li>1 teaspoon vanilla extract</li>
              <li>1 cup chocolate chips</li>
            </ol>
          </div>
           <div className="singleRecipeBotLeftItem">
            <div className="singleRecipeBotLeftItemTop">For the Stuffing:</div>
            <ol>
              <li>1 cup boiled and mashed potatoes</li>
              <li>1/2 cup finely chopped onions</li>
              <li>1/4 cup chopped coriander leaves</li>
              <li>1 teaspoon finely chopped green chilies (adjust to taste)</li>
              <li>1/2 teaspoon cumin powder</li>
              <li>1/2 teaspoon garam masala</li>
              <li>Salt to taste</li>
            </ol>
          <hr />
          <div className="flexitemrecipe">
            <img src={Recpiesimg2} alt="Recpiesimg2" />
            Nandi Chakki Fresh Atta
          </div>
        </div>
        <div className="singleRecipeBotRight">
          <div className="singleRecipeBotRightTop">Instructions</div>
          <ol>
            <li>
            Preheat your oven to 350°F (175°C). Line baking sheets with parchment paper.
            </li>
            <li>In a bowl, whisk together whole wheat flour, baking soda, and salt.</li>
            <li>In another large bowl, cream together the softened butter, brown sugar, and granulated sugar until smooth.</li>
            <li>Beat in the egg and vanilla extract until well combined.</li>
            <li>Gradually add the dry ingredients to the wet ingredients, mixing until just combined.</li>
            <li>Fold in the chocolate chips.</li>
            <li>Drop rounded tablespoons of dough onto the prepared baking sheets, spacing them about 2 inches apart.</li>
            <li>Bake for 10-12 minutes or until the edges are golden brown.</li>
            <li>Allow the cookies to cool on the baking sheets for a few minutes before transferring them to a wire rack to cool completely.</li>
          </ol>
        </div>
      </div>
      <div className="singleRecipeEnd">
        <div className="singleRecipeEndTitle">You Might Also Like</div>
        <div className="singleRecipeEndItems">
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/soojidhokla">
              <img src={Recpiesimg3} alt="Recpiesimg3" />
              <div className="singleRecipeEndItemTitle">
              Sooji Dhokla
              </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 30 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/Nandisabjimasala">
              <img src={Recpiesimg4} alt="Recpiesimg4" />
              <div className="singleRecipeEndItemTitle">Nandi Sabji Masala</div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 40 mins</span>
            </div>
          </div>
          <div className="singleRecipeEndItem">
            <div className="singleRecipeEndItemTop">
            <a href="/recipes/mixvegparatha">
              <img src={Recpiesimg5} alt="Recpiesimg5" />
              <div className="singleRecipeEndItemTitle">
              Mix Veg Paratha
              </div>
              </a>
            </div>
            <div>
              <img src={Timer} alt="Timer" />
              <span>Ready in 50 mins</span>
            </div>
          </div>
        </div>
      </div>
      <Footer /> */}
    </>
  );
};

export default Wholeattacookies;
